module.exports = __webpack_public_path__ + "img/Speaker=Indra Sofian.89db3cca.png";